import React from "react";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import Logo from "shared/Logo/Logo";
import {Disclosure} from "@headlessui/react";
import {NavItemType} from "./NavigationItem";
import {NAVIGATION_DEMO} from "data/navigation";
import SocialsList from "shared/SocialsList/SocialsList";
import SwitchDarkMode from "shared/SwitchDarkMode/SwitchDarkMode";
import {useLogoutMutation} from "store/api";
import {useAuth} from "contexts/AuthContext";

export interface NavMobileProps {
  data?: NavItemType[];
  onClickClose?: () => void;
}

const NavMobile: React.FC<NavMobileProps> = ({
  data = NAVIGATION_DEMO,
  onClickClose,
}) => {
  const [logout] = useLogoutMutation();
  const {logout: logoutStorage, isLoggedIn} = useAuth();

  const handleLogout = async () => {
    const user = JSON.parse(localStorage.getItem("user") as string);
    const {data} = await logout(user.token);
    if (data) {
      logoutStorage();
      if (onClickClose) onClickClose();
    }
  };

  const _renderItem = () => {
    return (
      <Disclosure as="li" className="text-neutral-900 dark:text-white ml-4">
        <span onClick={handleLogout}>Logout</span>
      </Disclosure>
    );
  };

  return (
    <div className="overflow-y-auto w-full h-screen-[50vh] py-2 transition transform shadow-lg ring-1 dark:ring-neutral-700 bg-white dark:bg-neutral-900 divide-y-2 divide-neutral-100 dark:divide-neutral-800">
      <div className="py-6 px-5">
        <Logo />
        <div className="flex flex-col mt-5 text-neutral-700 dark:text-neutral-300 text-sm">
          {/* <span>
            Discover the most outstanding articles on all topics of life. Write
            your stories and share them
          </span> */}

          <div className="flex justify-between items-center mt-4">
            <SocialsList itemClass="w-9 h-9 flex items-center justify-center rounded-full bg-neutral-100 text-xl dark:bg-neutral-800 dark:text-neutral-300" />
            <span className="block">
              <SwitchDarkMode className="bg-neutral-100 dark:bg-neutral-800" />
            </span>
          </div>
        </div>
        <span className="absolute right-2 top-2 p-1">
          <ButtonClose onClick={onClickClose} />
        </span>
      </div>
      {isLoggedIn && (
        <ul className="flex flex-col py-6 px-2 space-y-1">{_renderItem()}</ul>
      )}
    </div>
  );
};

export default NavMobile;
